import React, { ReactNode } from 'react';
import CircularProgress from '@material-ui/core/CircularProgress';
import { Button as MaterialButton } from '@material-ui/core';
import './LoaderButton.scss';

interface TOAButton {
	children: ReactNode;
	loading: boolean;
	type: 'button' | 'submit' | 'reset' | undefined;
	onHandleClick?: () => void;
	startIcon?: ReactNode;
	style?: object;
	className?: string;
	classes?: any;
	variant?: 'outlined' | 'contained' | 'text';
	color?: 'primary' | 'secondary' | 'none';
	disabled?: boolean;
	id?: string;
}

const TOAButton: React.FC<TOAButton> = (props: TOAButton) => {
	const { loading, onHandleClick, style, disabled, id, color, ...otherProps } = props;

	return (
		<div className='loader-button-root' style={style} id={id}>
			<div className='loader-button-wrapper'>
				<MaterialButton {...(color !== 'none' && { color: color })} disabled={loading || disabled} onClick={onHandleClick} {...otherProps}>
					{props.children}
				</MaterialButton>
				{loading && <CircularProgress size={24} className='loader-button-progress' />}
			</div>
		</div>
	);
};

TOAButton.defaultProps = {
	variant: 'contained',
	color: 'primary'
};

export default TOAButton;
